import browserDetect from "../../utils/browserDetect";
import { fileURL } from "../../domain/plasmid";

//= ==============================================================
function openSequenceChrome(url) {
	const customLinkName = "temporaryAnchor";
	const existingLink = document.getElementById(customLinkName);
	if (existingLink) {
		existingLink.parentNode.removeChild(existingLink);
	}
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.innerHTML = customLinkName;
	anchor.setAttribute("id", customLinkName);
	anchor.setAttribute("style", "display:none;");
	anchor.setAttribute("target", "");
	document.body.appendChild(anchor);

	const createdLink = document.getElementById(customLinkName);
	if (createdLink === null || createdLink === undefined) return;

	let triggered = false;

	if (createdLink.dispatchEvent) {
		//   console.log("dispatching" + url);

		const event = new MouseEvent("click", {
			bubbles: true,
			cancelable: true,
			view: window,
		});

		if (createdLink.dispatchEvent(event)) triggered = true;
	}

	if (!triggered && createdLink.click) {
		createdLink.click();
	}
}

//= ==============================================================
/*
function openSequenceMozilla(url) {
	const customFrameName = "temporaryFrame";
	const existingFrame = document.getElementById(customFrameName);
	if (existingFrame) {
		existingFrame.parentNode.removeChild(existingFrame);
	}
	const frame = document.createElement("iframe");
	frame.setAttribute("id", customFrameName);
	frame.setAttribute("style", "display:none;");
	frame.setAttribute("src", "about:blank");
	document.body.appendChild(frame);

	const createdFrame = document.getElementById(customFrameName);
	if (createdFrame === null || createdFrame === undefined) {
		return;
	}
	try {
		createdFrame.contentWindow.location.href = url;
	} catch (e) {
		// console.log(e);
	}
}
*/

const openSequence = url => {
	const browser = browserDetect();
	// protocolSupported = false;

	// Safari, Chrome, Opera 15+
	if (browser === "Safari" || browser === "Chrome" || browser === "Opera") {
		openSequenceChrome(url);
	}
	// Firefox
	else if (browser === "Firefox") {
		openSequenceChrome(url);
	}
	// Internet Explorer
	else if (browser === "IE") {
		openSequenceChrome(url);
	}
	// Microsoft Edge
	else if (browser === "Edge") {
		openSequenceChrome(url);
	} else {
		// console.log("[openSequence, browser]", browser);
	}
};

export const setProtocol = (protocol, closeModal, props) => {
	const { plasmidName, filePath } = props;
	closeModal();
	const lastURL = fileURL(protocol, plasmidName, filePath);
	openSequence(lastURL);
};
